import { useEffect } from "react";
import "./Toast.css";

/** A single dismissible notice, filed top-center. severity: "success" | "error". */
function Toast({ open, message, severity = "success", onClose, duration = 6000 }) {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  if (!open) return null;

  return (
    <div className="booth-toast-wrap" role="status" aria-live="polite">
      <div className={`booth-toast booth-toast--${severity}`}>
        <span className="booth-toast-message">{message}</span>
        <button type="button" className="booth-toast-close" aria-label="Dismiss" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default Toast;
